<template>
  <div>
    <!-- Step Indicator -->
    <div class="stepper-container" v-if="currentStep > 0">
      <div class="step" v-bind:class="{ selected: currentStep >= 0 }"></div>
      <div
        class="step"
        v-show="maxSteps === 4"
        v-bind:class="{ selected: currentStep >= 1 }"
      ></div>
      <div class="step" v-bind:class="{ selected: currentStep >= 2 }"></div>
      <div class="step" v-bind:class="{ selected: currentStep >= 3 }"></div>
    </div>

    <!-- Steps -->
    <template v-if="currentStep === 0">
      <Selection v-on:next="next(0)"></Selection>
    </template>
    <template v-if="currentStep === 1">
      <RecipientDetails v-on:next="next(1)"></RecipientDetails>
    </template>
    <template v-if="currentStep === 2">
      <SupporterDetails v-on:next="next(2)"></SupporterDetails>
    </template>
    <template v-if="currentStep === 3">
      <Payment
        :thankYouUrl="thankYouUrl"
        :useProductThankYouUrl="useProductThankYouUrl"
        @reset="reset"
        v-on:next="next(3)"
      ></Payment>
    </template>
  </div>
</template>

<script>
import Selection from "./Selection.vue"; // Step 1
import RecipientDetails from "./RecipientDetails.vue"; // Step 2
import SupporterDetails from "./SupporterDetails.vue"; // Step 3
import Payment from "./Payment.vue"; // Step 4

import { mapState } from "vuex";

export default {
  name: "Stepper",
  components: {
    Selection,
    RecipientDetails,
    SupporterDetails,
    Payment,
  },

  data() {
    return {
      currentStep: 0,
    };
  },
  props: {
    thankYouUrl: {
      type: String,
      default: null,
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    maxSteps() {
      if (this.isAdoption && !this.isGiftSelected) return 3;
      if (this.isAdoption && this.isGiftSelected) return 4;
      if (this.isWildcard) return 4;
      return 3;
    },
    isGiftSelected() {
      return this.donation.isGift;
    },
    isAdoption() {
      return this.product.producttype == "adoption";
    },
    isWildcard() {
      return this.product.producttype == "wildcard";
    },
    ...mapState({
      donation: (state) => state.donation.donation,
      product: (state) => state.product.product,
    }),
  },

  methods: {
    next(oldStep) {
      // this.currentStep = 3;
      if (this.maxSteps === 3 && oldStep === 0) {
        this.currentStep = 2;
      } else {
        this.currentStep = ++oldStep;
      }

      this.donation.formWizardCurrentStep = this.currentStep;

      // Move to top of the form
      const el = document.getElementById("donate-form");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    reset() {
      this.currentStep = 0;
      this.$emit("reset");
    },
  },
};
</script>


// WEBPACK FOOTER //
// Stepper.vue?b9aed34a